import { Spin } from 'antd'
import { Moment } from 'moment'
import { useTranslation } from 'react-i18next'

import { GetWashingCountByDayResponse } from '@/types/apis/washingCount'
import { formatDateSendRequest, formatYMD } from '@/utils/date'
import { formatJapaneseNumber } from '@/utils/formatPrice'

import {
  ContainerTable,
  DataCellWrapper,
  HeaderCelDate,
  HeaderCellWrapper,
  TableCustom,
  TableWrapper,
  Wrappertable,
} from '../styles'

type Props = {
  responseWashingCount: GetWashingCountByDayResponse | undefined
  responseWashingCountLoading?: boolean
  dateFilter?: Moment | null
}

const WashingCountByDayTable = ({ responseWashingCount, responseWashingCountLoading, dateFilter }: Props) => {
  const { t } = useTranslation()
  const dataSource = responseWashingCount?.items

  return (
    <ContainerTable>
      <Spin spinning={responseWashingCountLoading}>
        <TableWrapper>
          <Wrappertable>
            <TableCustom>
              <tbody>
                <tr>
                  <HeaderCelDate>{t('components.pages.washingCount.listReport.table.date')}</HeaderCelDate>
                  {dataSource?.map((item, index) => (
                    <HeaderCellWrapper key={index}>{item.name}</HeaderCellWrapper>
                  ))}
                  <HeaderCellWrapper>{t('components.pages.washingCount.listReport.table.total')}</HeaderCellWrapper>
                </tr>
                {dateFilter && (
                  <tr>
                    <DataCellWrapper>{formatYMD(formatDateSendRequest(dateFilter))}</DataCellWrapper>
                    {dataSource?.map((item, index) => (
                      <DataCellWrapper key={index}>{formatJapaneseNumber(item.count)}</DataCellWrapper>
                    ))}
                    <DataCellWrapper>{formatJapaneseNumber(responseWashingCount?.totalCount || 0)}</DataCellWrapper>
                  </tr>
                )}
              </tbody>
            </TableCustom>
          </Wrappertable>
        </TableWrapper>
      </Spin>
    </ContainerTable>
  )
}
WashingCountByDayTable.displayName = 'WashingCountByDayTable'
export default WashingCountByDayTable
